import React from "react";


function NoMatch(){
    return (

        <div className={"p-5 text-center justify-content-center align-content-center"}>
            <div className={"container"}>
                <h1>Noe gikk galt</h1>
                <h4>Denne siden eksisterer ikke :(</h4>
            </div>
        </div>


    );
}

export default NoMatch;